<template>
  <div>
    <transition name="slide-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
    name: 'app',
    components: {
        
    }
}
</script>
<style lang="scss">
@import "@/style/comon.scss";
html {
  @extend %bluebackground;
}
body {
  @extend %bluebackground;
}
@font-face {
    font-family: 'MuseoSans';
    font-style: normal;
    font-weight: normal;
    src: url("assets/fonts/MuseoSans.otf") format("truetype"); 
}
@font-face {
    font-family: 'MuseoSans900';
    font-style: normal;
    font-weight: bold;
    src: url("assets/fonts/exljbris - MuseoSans-900.otf") format("truetype"); 
}
@font-face {
    font-family: 'MuseoSans300';
    font-style: normal;
    font-weight: bold;
    src: url("assets/fonts/exljbris - MuseoSans-300.otf") format("truetype"); 
}
@font-face {
    font-family: 'MuseoSans500';
    font-style: normal;
    font-weight: bold;
    src: url("assets/fonts/exljbris - MuseoSans-500.otf") format("truetype"); 
}
@font-face {
    font-family: 'MuseoSans700';
    font-style: normal;
    font-weight: bold;
    src: url("assets/fonts/exljbris - MuseoSans-700.otf") format("truetype"); 
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}

.fade-in {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

h1 {
  font-family: "MuseoSans700", bold !important;
}

/*
*   Bounce
*/
.bounce-enter-active {
  animation: bounce-in 0.5s;
}
.bounce-leave-active {
  animation: bounce-in 0.5s reverse;
}
@keyframes bounce-in {
  0% {
    transform: scale(0);
  }
  100% {
    transform: scale(1);
  }
}


/*
*   Translate
*/
.translate-enter-active {
  animation: translate-in 0.5s;
}
.translate-leave-active {
  animation: translate-out 0.5s;
}
@keyframes translate-in {
  0% {
    transform: translateY(100%);
  }
  100% {
    transform: translateY(0%);
  }
}
@keyframes translate-out {
  0% {
    transform: translateY(0%);
  }
  100% {
    transform: translateY(-100%);
  }
}

.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.3s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter{
  transform: translateY(-500px);
  opacity: 0;
}
.slide-fade-leave-to {
  transform: translateY(-500px);
  opacity: 0;
}
.justify {
  text-align: justify; text-justify: inter-word;
}

</style>
